export default class MoreLess
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-more-less',
      wrapper: 'data-more-less-wrapper',
      button: 'data-more-less-button',
      buttonLabelOpen: 'data-more-less-label-open',
      buttonLabelClose: 'data-more-less-label-close',
    }
    
    this.showLesses = document.querySelectorAll(`[${this.settings.main}]`)
    
    if (!this.showLesses) return;
    
    return true;
  }
  
  setEvents()
  {
    this.showLesses.forEach(showLess => {
      const wrapper = showLess.querySelector(`[${this.settings.wrapper}]`);
      const button = showLess.querySelector(`[${this.settings.button}]`);
  
      button.addEventListener('click', () => {
        if (wrapper.hasClass('active')) {
          button.innerHTML = button.getAttribute(this.settings.buttonLabelOpen);
          wrapper.removeClass('active');
        } else {
          button.innerHTML = button.getAttribute(this.settings.buttonLabelClose);
          wrapper.addClass('active');
        }
      });
    })
  }
}
